export default __webpack_public_path__ + "static/media/mastercard.cb7d8d0d.png";